<div class="event-donator row">
	<div class="column small-12" *ngIf="checkboxButtonWrapper">
		<label>{{ 'event.donator.label' | translate }}</label>
	</div>
	<div class="column small-12" [class.checkbox-wrapper]="!checkboxButtonWrapper" [class.checkboxbutton-wrapper]="checkboxButtonWrapper" [formGroup]="form">
		<input type="checkbox" (change)="toggleShowDonation()" name="eventData.showDonation" value="1" id="showDonation" formControlName="eventData.showDonation">
		<label for="showDonation"><span [innerHTML]="'event.donator.showDonation' | translate "></span></label>
	</div>
	<ng-container *ngIf="donation?.donatorData?.showDonation === true">
		<textfield [(model)]="donation.donatorData.name" [fieldType]="'text'" [name]="'eventData.name'" [label]="'event.donator.name.label' | translate" [error]="'event.donator.name.error' | translate" [required]="true" [wrapperClass]="'columns small-12 medium-6'" [form]="form"></textfield>
		<messagefield [(model)]="donation.donatorData.message" [name]="'eventData.message'" [label]="'event.donator.message.label' | translate" [error]="'event.donator.message.error' | translate" [required]="false" [wrapperClass]="'columns small-12 medium-6'" [form]="form"></messagefield>
	</ng-container>

</div>
